import { Article } from '@phosphor-icons/react';
import styled from 'styled-components';
import {
  HideSearchInput,
  LoaderBar,
  OrganisationAvatar,
  TablePagination,
} from '../../components';
import { HoverBorderButton, MuteText, ShadowBox } from '../../elements';
import { InvoiceLogListHook } from '../../hooks';
import { CommonUtility, DateFormat, DateUtility, theme } from '../../utility';
import { Images } from '../../images';

const LogsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 13px;
  margin-bottom: 30px;
  .icon {
    min-width: 20px;
  }
`;

export function IvoiceLogs({ invoiceId, invoiceNumber }) {
  const {
    data: logs,
    filter,
    pageChanged,
    filterChanged,
    totalData,
    totalPages,
    loading,
    exportCSV,
    exporting,
  } = InvoiceLogListHook(invoiceId);

  return (
    <ShadowBox className="h-100 d-flex flex-column justify-content-between">
      {loading && <LoaderBar />}
      <div>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h3 className="m-0">History</h3>
          <div className="d-flex align-items-center">
            <HoverBorderButton
              borderColor={theme.colors.semanticBorder}
              size="mini"
              loading={exporting}
              onClick={() => exportCSV(invoiceNumber)}
              className="flex-btn"
            >
              Export
            </HoverBorderButton>
            <HideSearchInput
              search={filter.search}
              setSearch={search => filterChanged('search', search)}
              placeholder="Category, service & message"
              size="mini"
              iconSize={15}
              className="pr-0 col-10"
            />
          </div>
        </div>
        <LogsContainer>
          {CommonUtility.isValidArray(logs) ? (
            logs.map(log => (
              <div key={log?._id}>
                <div className="d-flex align-items-center">
                  <Article className="icon" size={17} color={theme.colors.grey} />
                  <span className="ml-1">{log.message}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  {log.performedBy?.name ? (
                    <div className="d-flex align-items-center mt-1">
                      <OrganisationAvatar name={log.performedBy?.name} mini />
                      <MuteText className="ml-1">{log.performedBy?.name}</MuteText>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center mt-1">
                      <OrganisationAvatar image={Images.logo} name="System" mini />
                      <MuteText className="ml-1">SKUPREME</MuteText>
                    </div>
                  )}
                  <MuteText>
                    {DateUtility.formatDate(log.createdAt, DateFormat.barChartMonth)}
                  </MuteText>
                </div>
              </div>
            ))
          ) : (
            <MuteText>No Logs</MuteText>
          )}
        </LogsContainer>
      </div>
      <TablePagination
        smallPagination
        currentPage={filter.page}
        totalPages={totalPages}
        pageChanged={pageChanged}
        pageSizeChanged={size => filterChanged('limit', size)}
        totalData={totalData}
      />
    </ShadowBox>
  );
}
